import type { CategoryDto } from '#Products/models/Pim/CategoryDto'

/**
 * Ancestor chain for visible breadcrumbs (R9): root → … → parent of `node`.
 * Prefers backend-ordered `selfAndAncestorsIds` (includes self); falls back to
 * climbing `parentsIds[0]` when that array is empty/missing.
 */
export function categoryAncestorChain(
  node: CategoryDto,
  byIds: Record<string, CategoryDto>,
): CategoryDto[] {
  const ids = node.selfAndAncestorsIds

  if (ids?.length) {
    return ids
      .slice(0, -1)
      .map(id => byIds[id])
      .filter((ancestor): ancestor is CategoryDto => ancestor != null)
  }

  const chain: CategoryDto[] = []
  let current = node

  for (let i = 0; i < Object.keys(byIds).length; i++) {
    const parentId = current.parentsIds?.[0]
    if (parentId == null) break

    const parent = byIds[parentId]
    if (!parent) break

    chain.unshift(parent)
    current = parent
  }

  return chain
}
